// megaMenu-close.js (or inline in your barba.js)
export function closeMaxMegaMenu() {
    // Use MMM's official API via jQuery if present (MMM enqueues it)
    const jq = window.jQuery || window.$;
    if (jq) {
        jq('ul.max-mega-menu').each(function () {
            const api = jq(this).data('maxmegamenu');
            if (!api) return;
            if (typeof api.hideAllPanels === 'function') api.hideAllPanels();   // desktop
            if (typeof api.hideMobileMenu === 'function') api.hideMobileMenu(); // mobile/off-canvas
        });
        return;
    }

    // Fallback: best-effort close if jQuery isn't ready (rare with MMM)
    document.querySelectorAll('.mega-menu-toggle[aria-expanded="true"]').forEach(btn => btn.click());
    document.querySelectorAll('.mega-menu li.mega-toggle-on')?.forEach(li => li.classList.remove('mega-toggle-on'));
    document.documentElement.classList.remove('mega-menu-open');
    document.body.classList.remove('mega-menu-open');
}
